import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BoxModelConstraint, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ComponentData } from '@ddt-web/data-service';
import { DEFAULT_DISCLOSURE_TEXT_CLASSES } from '@ddt-web/pdf-utils';

import { DisclosureComponent } from '../disclaimers/disclosure-component';
import { HeadingComponent, HeadingLevel } from '../heading/heading-component';

export class FreeFormComponent extends BusinessComponent {
	constructor(
		public dcrKey: string,
		private defaultText: string,
		private title?: string,
		private headingLevel: HeadingLevel = HeadingLevel.H1,
		public visible: boolean = true,
		public disclosureTextClasses: string[] = DEFAULT_DISCLOSURE_TEXT_CLASSES,
		public contentConstraints: Partial<BoxModelConstraint> = null
	) {
		super(dcrKey, 'FreeFormComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		if (this.title) {
			panels.push(...[new HeadingComponent(this.dcrKey + '_PDF_HEADER', this.title, this.headingLevel)]);
		}
		panels.push(...[new DisclosureComponent(this.dcrKey, this.defaultText, {}, this.contentConstraints, this.disclosureTextClasses)]);

		return panels;
	}
}
